// extracted by mini-css-extract-plugin
export default {"photoPost":"ProfilePhotoPost_photoPost__-HnIO","file":"ProfilePhotoPost_file__3KvS0","preview":"ProfilePhotoPost_preview__5Ailw"};